import { render, staticRenderFns } from "./MovementCreate.vue?vue&type=template&id=297618d3&scoped=true"
import script from "./MovementCreate.vue?vue&type=script&lang=js"
export * from "./MovementCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297618d3",
  null
  
)

export default component.exports